export const iconFontAwesomePunctuationSymbolsSection = (
	<i className="fa-solid fa-section"></i>
);
